import React from "react";
import LaundryWoman from "../../../assets/images/cleaning-women.png";
import pickup from "../../../assets/images/pickup.png";
import Tshirt from "../../../assets/images/t-shirt.png";
import Arrow from "../../../assets/images/arrow.png";
import DryCleaning from "../../../assets/images/dry-cleaning.png";

const AboutUs = () => {
  return (
    <div id="aboutus" className="w-full py-[80px] scroll-mt-[90px] bg-white font-[inter]">

      {/* ===================== ABOUT US SECTION ===================== */}
      <section className="max-w-[1150px] mx-auto grid lg:grid-cols-2 items-center bg-[#FFF6F7] h-auto xl:h-[476px] px-6 md:px-10 py-10 gap-10">

        {/* LEFT IMAGE BOX */}
        <div className="rounded-t-[120px] overflow-hidden flex justify-center items-center p-6">
          <img
            src={LaundryWoman}
            alt="Laundry Woman"
            className="w-full max-w-[380px] h-auto object-contain"
          />
        </div>

        {/* RIGHT TEXT BOX */}
        <div>
          <h2 className="text-3xl md:text-[48px] font-semibold mb-6">
            About Us
          </h2>

          <h3 className="text-[22px] md:text-[26px] font-semibold mb-6">
            Connecting You to Clean Clothes
          </h3>

          <p className="text-[15px] md:text-[16px] text-[#505050] leading-relaxed mb-4">
            Saaflo isn’t a laundry shop — we’re your gateway to verified local laundry experts. By partnering only with top-rated vendors, we ensure that you get fast pick-up, expert cleaning, and hassle-free doorstep delivery, every time.
          </p>

          <p className="mb-2 italic font-medium">
            “Our mission is simple help every customer find the right laundry solution, with dedicated support at each step from booking through final delivery. Experience easy laundry, powered by choice and convenience.”
          </p>

          <p className="mt-6 font-medium italic text-[#FF7F50]">
            MOHANABALAJI (Founder)  
          </p>
        </div>
      </section>

      {/* ===================== OUR PROCESS SECTION ===================== */}
      <section className="py-20 bg-white max-xl:px-20">
        <h2 className="text-[32px] md:text-[36px] font-semibold text-center mb-12">
          Our Process
        </h2>

        {/* Responsive Layout */}
        <div className="flex flex-col items-center justify-between max-w-5xl mx-auto md:flex-row gap-14 md:gap-6">

          {/* STEP 1 */}
          <div className="flex flex-col items-center text-center max-w-[260px]">
            <img src={Tshirt} className="w-[44px] mb-4" alt="Tshirt" />
            <h3 className="text-[22px] md:text-[24px] font-semibold mb-2">
              Pick Your Dirty Cloths
            </h3>
            <p className="text-sm text-[#8D8D90] mt-1">
              Schedule a pickup through our website or app and pack your dirty laundry.
            </p>
          </div>

          {/* ARROW */}
          <div className="items-center justify-center hidden lg:flex">
            <img src={Arrow} className="w-[86px] mb-24" alt="Arrow" />
          </div>

          {/* STEP 2 */}
          <div className="flex flex-col items-center text-center max-w-[260px]">
            <img src={DryCleaning} className="w-[44px] mb-4" alt="Dry Cleaning" />
            <h3 className="text-[22px] md:text-[24px] font-semibold mb-2">
              Laundry Vendors
            </h3>
            <p className="text-sm text-[#8D8D90] mt-1">
              Your clothes are sorted, washed with high-quality detergents, and steam-pressed.
            </p>
          </div>

          {/* ARROW  */}
          <div className="items-center justify-center hidden lg:flex">
            <img src={Arrow} className="w-[86px] mb-24" alt="Arrow" />
          </div>

          {/* STEP 3 */}
          <div className="flex flex-col items-center text-center max-w-[260px]">
            <img src={pickup} className="w-[44px] mb-4" alt="Pickup" />
            <h3 className="text-[22px] md:text-[24px] font-semibold mb-2">
              Pick Up Your Laundry
            </h3>
            <p className="text-sm text-[#8D8D90] mt-1">
              Once ready, we deliver your freshly cleaned and neatly folded clothes.
            </p>
          </div>
        </div>
      </section>
    </div>
  );
};

export default AboutUs;
